
module.exports = {
	isGifByExtension: function (url) {
		// 檢查 .gif 或 .gif?queryString
		return /\.gif(\?.*)?$/i.test(url);
	},
	getURLParameter: function () {
		const obj = new Object();
		const curUrl = window.location.href;
		let index = curUrl.indexOf('?');
		if (index >= 0) {
			const strParams = curUrl.substring(index + 1);
			const urlVariables = strParams.split('&');
			urlVariables.forEach((strVariable) => {
				index = strVariable.indexOf('=');
				const paramKey = strVariable.substring(0, index);
				const paramValue = strVariable.substring(index + 1);
				obj[paramKey] = paramValue;
			});
		}
		return obj;
	},
	getGateServer: function (domain) {
		return new Promise((resolve, reject) => {
			// to get server ip & port
			const apiCommand = `${document.location.origin}/APIs/GetGateServer.ashx`;
			const apiData = domain ? { Domain: domain } : {};
			fetch(apiCommand, {
				body: JSON.stringify(apiData),
				headers: {
					'user-agent': 'Mozilla/4.0 MDN Example',
					'content-type': 'application/json'
				},
				method: 'POST', // *GET, POST, PUT, DELETE, etc.
				mode: 'cors', // no-cors, cors, *same-origin
				redirect: 'follow', // manual, *follow, error
				referrer: 'no-referrer', // *client, no-referrer
			})
				.then(function (response) {
					return response.json();
				})
				.then(function (data) {
					if (data.ResultCode !== "OK") throw new Error('failed to get server ip & port');
					const info = data.ResultObject;
					const protocol = info.protocol;
					const domain = info.domain;
					const ip = info.ip;
					const port = info.port;
					const uniPlayList = info.uniPlayList;
					resolve({
						protocol,
						domain,
						ip,
						port,
						uniPlayList
					});
				})
				.catch(function (err) {
					reject(err.message ? err.message : err);
				});
		});
	},
	// detectmob: function () {
	// 	if (navigator.userAgent.match(/Android/i) ||
	// 		navigator.userAgent.match(/webOS/i) ||
	// 		navigator.userAgent.match(/iPhone/i) ||
	// 		navigator.userAgent.match(/iPad/i) ||
	// 		navigator.userAgent.match(/iPod/i) ||
	// 		navigator.userAgent.match(/BlackBerry/i) ||
	// 		navigator.userAgent.match(/Windows Phone/i)) {
	// 		return true;
	// 	}
	// 	else {
	// 		return false;
	// 	}
	// },
	detectmob: (function() {
		let result = null;
		return function() {
			if (result === null) {
				const ua = navigator.userAgent;
				result = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(ua);
			}
			return result;
		};
	})(),
	detectmobiOS: (function() {
		let result = null;
		return function() {
			if (result === null) {
				const ua = navigator.userAgent;
				result = /iPhone|iPad|iPod/i.test(ua);
			}
			return result;
		};
	})(),
	// detectmobiOS: function () {
	// 	if (navigator.userAgent.match(/iPhone/i) ||
	// 		navigator.userAgent.match(/iPad/i) ||
	// 		navigator.userAgent.match(/iPod/i)) {
	// 		return true;
	// 	}
	// 	else {
	// 		return false;
	// 	}
	// },
	// 退出全屏
	exitFullscreen: function () {
		let el = document
		let cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen
		if (cfs) { // typeof cfs != "undefined" && cfs
			cfs.call(el)
		}
		else if (typeof window.ActiveXObject !== 'undefined') {
			// for IE，这里和fullScreen相同，模拟按下F11键退出全屏
			let wscript = new window.ActiveXObject('WScript.Shell')
			if (wscript != null) {
				wscript.SendKeys('{F11}')
			}
		}
	},
	enterFullScreen: function () {
		let el = document.documentElement
		let rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
		if (rfs) { // typeof rfs != "undefined" && rfs
			rfs.call(el)
		}
		else if (typeof window.ActiveXObject !== 'undefined') {
			// for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
			let wscript = new window.ActiveXObject('WScript.Shell')
			if (wscript != null) {
				wscript.SendKeys('{F11}');
			}
		}
	},
	postAPI: function (url, data, contentType) {
		return new Promise((resolve, reject) => {
			const apiDomain = document.location.origin;
			const apiCommand = `${apiDomain}/${url}`;
			let apiData;
			if (contentType) {
				switch (contentType.toString().toLowerCase()) {
					case 'json': {
						contentType = 'application/json';
						apiData = JSON.stringify(data);
						break;
					}
					case 'x-www-form-urlencoded': {
						contentType = 'application/x-www-form-urlencoded; charset=UTF-8';

						const formBody = [];
						for (const property in data) {
							const encodedKey = encodeURIComponent(property);
							const encodedValue = encodeURIComponent(data[property]);
							formBody.push(encodedKey + "=" + encodedValue);
						}
						apiData = formBody.join("&");
						break;
					}
					default: {
						contentType = 'application/json';
						apiData = JSON.stringify(data);
						break;
					}
				}
			}
			else {
				contentType = 'application/json';
				apiData = JSON.stringify(data);
			}

			fetch(apiCommand, {
				body: apiData,
				headers: {
					'user-agent': 'Mozilla/4.0 MDN Example',
					'content-type': contentType
				},
				method: 'POST', // *GET, POST, PUT, DELETE, etc.
				mode: 'cors', // no-cors, cors, *same-origin
				redirect: 'follow', // manual, *follow, error
				referrer: 'no-referrer', // *client, no-referrer
			})
				.then(function (response) {
					return response.json();
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (err) {
					reject(err);
				});
		});
	}
};